import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const inspectionTypesAdapter = getAdapter({ idFieldName: 'value' });

const inspectionTypesSlice = createSlice({
  name: 'inspectionTypes',
  initialState: inspectionTypesAdapter.getInitialState(),
  reducers: {
    setInspectionTypes: (state, { payload: { inspectionTypes } }) => {
      inspectionTypesAdapter.setAll(state, inspectionTypes);
    },
  },
});

const selectors = inspectionTypesAdapter.getSelectors(({ inspectionTypes }) => inspectionTypes);

export const getInspectionTypes = (state) => selectors.selectAll(state);

export const { setInspectionTypes } = inspectionTypesSlice.actions;

export default inspectionTypesSlice.reducer;
